import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createSlots as _createSlots, withDirectives as _withDirectives, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-66092406"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "message-list"
}
const _hoisted_2 = { class: "create-time" }

import { reactive, ref, watch, Component } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { MessageData, MessageTemplate } from '@/services/message.service'
import { MessageDetailsService } from '@/views/_components/message-details/message-details.service'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import FeatureRelease from '@/views/_components/message-template/feature-release/feature-release.vue'
import { deserialize, unique } from '@/utils/tool'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import LoadMoreButton from '@/components/load-more-button.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'message-details',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const injector = useReflectiveInjector([MessageDetailsService])
const service = injector.get(MessageDetailsService) as MessageDetailsService

const isLoading = ref(false)
const messageList = ref<MessageData[]>([])
const hasMore = ref(true)
const pagination = reactive({
  page: 1,
  limit: 20,
  total: 0,
})

function updateData(isLoadMore: boolean = false) {
  if (!isLoadMore) {
    pagination.page = 1
    messageList.value = []
  }
  isLoading.value = true
  service.getMessageList({
    page: pagination.page,
    limit: pagination.limit,
  }).then((response) => {
    if (pagination.page === 1) {
      messageList.value = response.data || []
    } else {
      messageList.value = [...messageList.value, ...(response.data || [])]
    }
    pagination.total = +response.total || 0
    hasMore.value = messageList.value.length < pagination.total
  }).finally(() => {
    isLoading.value = false
  })
}

function loadMoreData() {
  console.log(111)
  if (!hasMore.value || isLoading.value) return
  pagination.page = pagination.page + 1
  updateData(true)
}

function handleClose() {
  emits('update:modelValue', false)
}

function getMessageComponent(notifyType: number): Component {
  return MessageTemplate[notifyType] || FeatureRelease
}

watch(() => props.modelValue, (value) => {
  if (!value) return
  updateData()
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    title: _ctx.$t('messageTemplate.title'),
    "model-value": __props.modelValue,
    "show-close": "",
    size: 700,
    onClose: handleClose
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(ContentAdaptLayout, {
        class: "message-details-wrap important",
        loading: isLoading.value,
        "has-more": hasMore.value,
        onLoadMore: loadMoreData
      }, _createSlots({
        default: _withCtx(() => [
          (messageList.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["message-item el-card cm-message-template", { 'is-unread': !item.is_read }]),
                    key: index
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(getMessageComponent(item.notify_type)), {
                      content: item.content,
                      header: item.title,
                      onCloseDetails: handleClose
                    }, null, 40, ["content", "header"])),
                    _createElementVNode("div", _hoisted_2, _toDisplayString(item.create_time), 1)
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!messageList.value.length)
            ? (_openBlock(), _createBlock(EmptyData, {
                key: 1,
                height: "100%"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, [
        (messageList.value.length)
          ? {
              name: "footer",
              fn: _withCtx(() => [
                _createVNode(LoadMoreButton, {
                  loading: isLoading.value,
                  current: messageList.value.length,
                  total: pagination.total,
                  onLoadMore: loadMoreData
                }, null, 8, ["loading", "current", "total"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["loading", "has-more"])), [
        [_directive_loading, isLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["title", "model-value"]))
}
}

})